<template>
    <div class="classroom-management">
        <!-- 教室相关表单弹框 -->
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            :close-on-click-modal="false"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="所属门店: " prop="storeId">
                    <el-select v-model="dialog.content.storeId" placeholder="请选择门店">
                        <el-option 
                            v-for="store in storeList" 
                            :key="store.value" 
                            :label="store.name"
                            :value="store.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="教室封面图: " prop="coverUrl">
                    <el-upload
                        :action="imageUploadUrl"
                        :headers="{'X-token': token}"
                        :show-file-list="false"
                        :on-success="handleUploadSuccess">
                        <el-button type="primary" size="small">
                            <i class="el-icon-plus"></i>
                            选择图片
                        </el-button>
                    </el-upload>
                    <img :style="{
                        'width': '100%'
                    }" v-if="dialog.content.coverUrl != ''" :src="'https://www.7amdancestudio.cn/image/' + dialog.content.coverUrl">
                </el-form-item>
                <el-form-item label="价格模板: " prop="priceMouldId" v-if="dialog.type === 'insert'">
                    <el-select v-model="dialog.content.priceMouldId" placeholder="请选择模板">
                        <el-option 
                            v-for="item in moduleList" 
                            :key="item.value" 
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="教室名称: " prop="classroomName">
                    <el-input v-model="dialog.content.classroomName" placeholder="请输入教室名称"></el-input>
                </el-form-item>
                <el-form-item label="教室面积: " prop="area">
                    <el-input v-model="dialog.content.area" placeholder="请输入教室面积"></el-input>
                </el-form-item>
                <el-form-item label="教室级别: " prop="level">
                    <el-input v-model="dialog.content.level" placeholder="请输入教室级别"></el-input>
                </el-form-item>
                <el-form-item label="人数范围下限: " prop="numberLow">
                    <el-input v-model="dialog.content.numberLow" placeholder="人数范围下限"></el-input>
                </el-form-item>
                <el-form-item label="人数范围上限: " prop="numberHight">
                    <el-input v-model="dialog.content.numberHight" placeholder="请输入人数范围上限"></el-input>
                </el-form-item>
                <el-form-item label="开业起始时间: " prop="businessStartHour">
                    <el-input v-model="dialog.content.businessStartHour" placeholder="请输入开业起始时间"></el-input>
                </el-form-item>
                <el-form-item label="开业结束时间: " prop="businessEndHour">
                    <el-input v-model="dialog.content.businessEndHour" placeholder="请输入开业结束时间"></el-input>
                </el-form-item>
                <el-form-item label="智能音响标识: " prop="soundCode">
                    <el-input v-model="dialog.content.soundCode" placeholder="请输入智能音响标识"></el-input>
                </el-form-item>
                <el-form-item label="智能开关标识: " prop="switchDeviceId">
                    <el-input v-model="dialog.content.switchDeviceId" placeholder="请输入智能开关标识"></el-input>
                </el-form-item>
                <el-form-item label="智能门锁标识: " prop="gateLock">
                    <el-input v-model="dialog.content.gateLock" placeholder="请输入智能门锁标识"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>

        <!-- 时段相关弹框 -->
        <el-dialog
            :visible.sync="dialogSlot.visible"
            @close="handleSlotCancel()"
            :close-on-click-modal="false"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{ dialogSlot.title }}
            </div>
            <el-form :model="dialogSlot.content" ref="formContentSlot" label-width="60px">
                <el-form-item label="日期: ">
                    <el-date-picker
                        v-model="dialogSlot.content.courseDate"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        @change="handleDateChange()"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="slot-result">
                已选时段: 
                <span :style="{'color': '#5473E8'}" v-if="dialogSlot.content.slotIdList != ''">{{ dialogSlot.currentSlot }}</span>
                <span :style="{'color': '#9d9d9d', 'margin-left': '0.8rem'}" v-else>暂无选中时段</span>
            </div>
            <div class="course-wrapper">
                <div>
                    已选课程: 
                    <span :style="{'color': '#5473E8'}" v-if="dialogCourse.currentCourseName">{{ dialogCourse.currentCourseName }}</span>
                    <span :style="{'color': '#9d9d9d', 'margin-left': '0.8rem'}" v-else>暂无选中课程</span>
                </div>
                <el-button type="text" :style="{'padding': '0'}" @click="handleChooseCourse()">选择课程</el-button>
            </div>
            <div class="slot-panel">
                <div class="slot-item" :class="{
                    'disabled': slot.status === 2,
                    'selected': slot.selected
                }" v-for="slot in slotList" :key="slot.slotId + slot.selected" @click="checkSlot(slot)">
                    <p class="day">{{ slot.startTime }} - {{ slot.endTime }}</p>
                    <p class="status-info" v-if="slot.status === 3">{{ slot.statusInfo }}</p>
                    <p class="status-info" v-if="slot.status === 2">该时段不可选</p>
                    <p class="status-info" v-if="slot.status === 1">¥{{ slot.price }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" size="small" >设为已选</el-button> -->
                <el-button type="primary" size="small" @click="submitCourse()">确定提交</el-button>
            </span>
        </el-dialog>

        <!-- 课程相关弹框 -->
        <el-dialog
            :visible.sync="dialogCourse.visible"
            @close="handleCourseCancel()"
            :close-on-click-modal="false"
            :custom-class="'course-dialog'"
            width="60%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{ dialogCourse.title }}
            </div>
            <div class="course-panel">
                <div class="course-item" 
                    v-for="course in dialogCourse.courseList" 
                    :key="course.courseId"
                    @click="chooseCourse(course)">
                    <img class="cover-img" :src="'https://www.7amdancestudio.cn/image/' + course.coverUrl">
                    <span :style="{'line-height': '4rem', 'font-size': '1.6rem', 'margin-left': '1.2rem'}">{{ course.courseName }}</span>
                </div>
            </div>

            <el-pagination
                :current-page="dialogCourse.currentPage"
                :page-size="dialogCourse.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="dialogCourse.pageTotal"
                @current-change="handleCoursePageChange"
                @size-change="handleCourseSizeChange">
            </el-pagination>
        </el-dialog>

        <!-- 初始化时段弹框 -->
        <el-dialog :visible.sync="dialogInitSlot.visible" width="20%" @close="handleInitSlotCancel()">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                初始化教室时段
            </div>
            <el-form :model="dialogInitSlot.content" ref="formInitSlot" label-width="80px">
                <el-form-item label="起始日期: ">
                    <el-date-picker
                        v-model="dialogInitSlot.content.day"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="价格模板: ">
                    <el-select v-model="dialogInitSlot.content.priceMouldId" placeholder="请选择模板">
                        <el-option 
                            v-for="item in moduleList" 
                            :key="item.value" 
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleInitSlotCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submitInitSlot()">确定</el-button>
            </span>
        </el-dialog>

        <div class="el-card-title">
            <span>数据筛选</span>
        </div>
        <div class="filter-row">
            <div class="filter-item" v-if="!this.$store.getters.getUserInfo.storeId">
                <span class="filter-title">所属门店： </span>
                <el-select clearable v-model="pageCfg.storeId" @change="getClassroomList" placeholder="请选择所属门店">
                    <el-option v-for="(item, i) in storeList" :key="i" :label="item.name" :value="item.value"></el-option>
                </el-select> 
            </div>
        </div>
        <div class="el-card-title">
            <span>教室列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增教室" placement="top">
                    <el-button type="text" @click="handleClassroomInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 760
        }">
            <template slot="coverUrl" slot-scope="item">
                <a :href="'https://www.7amdancestudio.cn/image/' + item.data.row.coverUrl" target="blank">查看图片</a>
            </template>
            <template slot="operation" slot-scope="item">
                <el-button type="text" size="small" @click="handleClassroomEdit(item.data.row)">编辑</el-button>
                <el-button type="text" size="small" @click="handleClassroomSlotEdit(item.data.row)">编辑时段</el-button>
                <el-button type="text" size="small" @click="handleInitSlot(item.data.row)">生成时段</el-button>
            </template>
        </custom-table>
    </div>
</template>

<script>
import { CourseManagementApi } from '../http/courseManagement/courseManagement';
import { ClassroomManagementApi } from '../http/classroomManagement/classroomManagement';
import { CommonApi } from '../http/common';
import { FileApi } from '../http/file';
import { Utils } from '../utils/index';
import CustomTable from '../components/customTable.vue';
export default {
    name: "classroom-management",
    components: {
        CustomTable
    },
    data(){
        return {
            tableData: {
                data: [],
                columns: [],
                tableLoading: false
            },
            pageCfg: {
                storeId: ""
            },
            storeList: [],
            classroomId: "",
            dialog: {
                title: "",
                visible: false,
                type: "",
                content: {
                    storeId: "",
                    priceMouldId: "",
                    level: "",
                    // classroomId: "",
                    area: "",
                    coverUrl: "",
                    classroomName: "",
                    numberLow: "",
                    numberHight: "",
                    businessStartHour: "",
                    businessEndHour: "",
                    gateLock: "",
                    soundCode: "",
                    switchDeviceId: ""
                }
            },
            dialogSlot: {
                title: "编辑时段",
                visible: false,
                currentSlot: "",                    // 当前选中的时段（用于展示文字）
                content: {
                    courseDate: "",                 // 当前选择日期
                    courseId: "",                   // 选中的课程id
                    classroomId: "",                // 当前教室的id
                    week: "",                       // 当前选中时间的周
                    storeId: "",                    // 当前门店id
                    slotIdList: ""                  // 当前选中的时段id
                }
            },
            dialogCourse: {
                title: "选择课程",
                visible: false,
                courseList: [],
                courseName: "",                     // 模糊搜索课程变量
                currentCourseName: "",              // 当前选中课程的名称
                currentPage: 1,                     // 当前页
                pageSize: 8,                       // 每页数量
                pageTotal: 0
            },
            dialogInitSlot: {
                visible: false,
                title: "初始化时段",
                content: {
                    day: "",
                    classroomId: "",
                    priceMouldId: ""
                }
            },
            slotList: [],
            imageUploadUrl: FileApi.imageUpload,
            // 认证token
            token: "",
            moduleList: [
                {
                    value: "1",
                    name: "模板1（中教室非24h）"
                },
                {
                    value: "2",
                    name: "模板2（迷你教室非24h）"
                },
                {
                    value: "3",
                    name: "模板3（中教室24h）"
                },
                {
                    value: "4",
                    name: "模板4（小教室24h）"
                },
                {
                    value: "5",
                    name: "模板5（哈西店，中教室24h）"
                },
                {
                    value: "6",
                    name: "模板6（哈西店，B教室24h）"
                },
                {
                    value: "7",
                    name: "模板7（哈西店，C教室24h）"
                },
                {
                    value: "8",
                    name: "模板8（小教室非24h）"
                },
                {
                    value: "9",
                    name: "模板9（学院路，中教室24h）"
                },
                {
                    value: "10",
                    name: "模板10（学院路，小教室有窗24h）"
                },
                {
                    value: "11",
                    name: "模板11（学院路，小教室无窗24h）"
                },
                {
                    value: "12",
                    name: "模板12（平房店，中教室非24h）"
                },
                {
                    value: "13",
                    name: "模板13（平房店，小教室非24h）"
                },
            ]
        }
    },
    // watch: {
    //     "$store.state.userInfo": {
    //         handler(newVal, oldVal){
    //             if(newVal != oldVal)
    //                 this.dialogSlot.content.storeId = newVal;
    //         }
    //     }
    // },
    mounted(){
        this.dialogSlot.content.courseDate = Utils.getSystemFullTime().date;
        this.dialogSlot.content.week = Utils.getSystemFullTime().week;
        // this.dialogSlot.content.storeId = this.$store.getters.getUserInfo.storeId ? ;
        this.token = localStorage.getItem('authToken');
        this.getStoreList();
        this.getClassroomList();
    },
    methods: {
        // 获取门店列表
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
            });
        },

        // 获取教室列表
        getClassroomList(){
            this.tableData.tableLoading = true;
            ClassroomManagementApi.getClassroomList({ storeId: this.pageCfg.storeId }).then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            })
        },

        // 获取教室时段列表
        getClassroomSlotList(){
            ClassroomManagementApi.getClassroomSlotList({
                classroomId: this.dialogSlot.content.classroomId,
                searchDay: this.dialogSlot.content.courseDate
            }).then(res => {
                this.slotList = [...res];
                // console.log(this.slotList, 'list');
            })
        },
        // 获取课程
        getCourseList(){
            CourseManagementApi.getCourseList({
                courseName: this.dialogCourse.courseName,
                currentPage: this.dialogCourse.currentPage,
                pageSize: this.dialogCourse.pageSize,
                storeId: this.dialogSlot.content.storeId
            }).then(res => {
                this.dialogCourse.courseList = res.data;
                this.dialogCourse.pageTotal = res.pageTotal;
                // this.dialogCourse.courseList = [...res.data].filter(item => { return item.slotNum === 0 });
                // this.dialogCourse.pageTotal = this.dialogCourse.courseList.length();
            })
        },
        chooseCourse(course){
            this.dialogSlot.content.courseId = course.courseId;
            this.dialogCourse.currentCourseName = course.courseName;
            // this.dialogCourse.visible = false;
            // this.dialogCourse.courseName = "";
            // this.dialogCourse.currentPage = 1;
            // this.dialogCourse.courseList = [];
            this.handleCourseCancel();
        },
        // 时段点击事件
        checkSlot(slot){
            if(slot.status != 1){
                this.$notify.warning({title: "该时段不可选，请选择其他时段"});
                return false;
            }
            slot.selected = !slot.selected;
            this.dialogSlot.content.slotIdList = this.slotList
                .filter(item => { return item.selected === true })
                .map(item => { return item.slotId })
                .join(",");
            this.dialogSlot.currentSlot = this.slotList
                .filter(item => { return item.selected === true })
                .map(item => { return item.startTime + '-' + item.endTime })
                .join(",");
        },

        // 教室相关表单关闭方法
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },

        // 时段相关弹框关闭方法
        handleSlotCancel(){
            this.dialogSlot.visible = false;
            for(let key in this.dialogSlot.content){
                this.dialogSlot.content[key] = "";
            }
            this.dialogCourse.currentCourseName = "";
        },

        handleInitSlotCancel(){
            this.dialogInitSlot.visible = false;
            for(let key in this.dialogInitSlot.content){
                this.dialogInitSlot.content[key] = "";
            }
        },
        // 课程相关弹框关闭方法
        handleCourseCancel(){
            this.dialogCourse.visible = false;
            this.dialogCourse.courseName = "";
            this.dialogCourse.currentPage = 1;
            this.dialogCourse.courseList = [];
        },

        // 编辑教室控制方法
        handleClassroomEdit(row){
            this.dialog.visible = true;
            this.dialog.title = "编辑教室";
            this.dialog.type = 'edit';
            this.classroomId = row.classroomId;
            for(let key in this.dialog.content){
                this.dialog.content[key] = row[key];
            }
        },

        // 时段编辑控制方法
        handleClassroomSlotEdit(row){
            this.dialogSlot.content.storeId = row.storeId;
            this.dialogSlot.content.classroomId = row.classroomId;
            this.dialogSlot.content.week = Utils.getSystemFullTime().week;
            this.dialogSlot.visible = true;
            this.getClassroomSlotList();
        },

        handleDateChange(){
            this.dialogSlot.content.week = Utils.getSystemFullTime(this.dialogSlot.content.courseDate).week;
            this.dialogSlot.content.slotIdList = "";
            this.dialogSlot.currentSlot = [];
            this.getClassroomSlotList();
        },
        // 选择课程控制方法
        handleChooseCourse(){
            if(this.dialogSlot.content.slotIdList === ""){
                this.$notify.warning({ title: "请至少选择一个时段" });
                return false;
            }
            this.dialogCourse.visible = true;
            this.getCourseList();
        },
        handleCoursePageChange(page){
            this.dialogCourse.currentPage = page;
            this.getCourseList();
        },
        handleCourseSizeChange(size){
            this.dialogCourse.pageSize = size;
            this.getCourseList();
        },
        // 新增教室控制方法
        handleClassroomInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增教室";
            this.dialog.type = 'insert';
        },

        // 图片上传成功回调方法
        handleUploadSuccess(res){
            this.dialog.content.coverUrl = res.content;
        },
        handleInitSlot(row){
            this.dialogInitSlot.content.classroomId = row.classroomId;
            this.dialogInitSlot.visible = true;
        },
        // 教室新增/编辑确认方法
        submit(){
            const record = {
                ...this.dialog.content
            }
            if(this.dialog.type === 'edit')
                record.classroomId = this.classroomId;
            ClassroomManagementApi[this.dialog.type === 'insert' ? 'insertClassroom' : 'updateClassroom'](record).then(res => {
                if(res.data.status === 200){
                    this.$notify.success({ title: this.dialog.type === 'insert' ? '新增教室成功': '编辑教室成功'});
                    this.handleCancel();
                    this.getClassroomList();
                }
            })
        },
        submitCourse(){
            const param = this.dialogSlot.content;

            // 拿到时段id的第一个用来找到报名截止时间
            const id = this.dialogSlot.content.slotIdList.split(',')[0]; 
            const time = this.slotList.find(item => { return item.slotId === id }).startTime + ":00";

            const courseDate = this.dialogSlot.content.courseDate + ' ' + time;

            const deadline = Utils.getSystemFullTime(new Date(courseDate).getTime() - 43200000);
            param.deadline = deadline.date + ' ' + deadline.time + ':00';

            ClassroomManagementApi.editClassroomSlot(param).then(res => {
                if(res.data.status === 200){
                    this.handleSlotCancel();
                    this.$notify.success({title: "时段已成功设置为课程"});
                    this.slotList = [];
                }
            });
        },
        submitInitSlot(){
            ClassroomManagementApi.initClassroomSlot(this.dialogInitSlot.content).then(res => {
                if(res.data.status === 200){
                    this.handleInitSlotCancel();
                    this.$notify.success({title: "初始化教室时段成功"});
                }
            });
        }
    }
}
</script>

<style lang="less">
div.classroom-management{
    .course-dialog{
        .el-dialog__body{
            padding-left: 0rem!important;
        }
    }
    .slot-result, .course-wrapper{
        padding: 0 0.4rem 1.2rem 0.4rem;
        font-weight: bold;
        color: #333333;
    }
    .course-wrapper{
        justify-content: space-between;
        display: flex;
    }

    .course-panel{
        flex-wrap: wrap;
        height: 52rem;
        display: flex;
        .course-item{
            background-color: #EBF4F9;
            border: .2rem solid #fff;
            width: calc(25% - 2.5rem);
            transition: all .3s ease;
            margin: 0 0 1.2rem 2rem;
            flex-direction: column;
            display: inline-flex;
            border-radius: .8rem;
            overflow: hidden;
            cursor: pointer;
            height: 25rem;
            // .cover-img{
            //     // border-radius: .8rem;
            // }
            &:hover{
                border-color: #7593CF;
            }
        }
    }
    // padding: 14px 20px;
}
</style>